"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translate_1 = require("utils/translate");
exports.default = (function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement("div", { className: "count-wrapper" },
        React.createElement("span", { className: 'count-icon' },
            React.createElement(sok_ui_1.Icon, { className: 'far fa-pen-square', size: props.isMobile ? '2x' : undefined, onClick: function () {
                    if (props.setCurrentInput && !props.disabled) {
                        props.setCurrentInput(__assign(__assign({}, props.item), { index: props.index }));
                        props.openModal();
                    }
                } })),
        React.createElement("div", { lang: selectedLanguage, className: "count-text" }, props.item.name),
        props.isMobile ? (React.createElement("div", { className: "count-input-mobile" }, props.item.count)) : (React.createElement(sok_ui_1.Input, { disabled: props.disabled, min: "0", type: "number", value: props.item.count, className: "count-input", onChange: function (e) {
                props.setCount(props.index, parseInt(e.target.value, 10));
            } }))));
});
